import { Grid, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FTLogo_White from '../../../../assets/images/pdf/FTLogo_White.png';
import GOEDigitalAdvisor from '../../../../assets/images/pdf/GOEDigitalAdvisor.svg';
import cover from '../../../../assets/images/pdf/cover.png';
import { Typography } from '../../../atoms';

const ImageContainer = styled('div')(() => ({
    height: '82%',
    width: '100%',
    backgroundImage: `url(${cover})`,
    backgroundSize: 'cover',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    zIndex: -1,
    backgroundPositionX: 'right',
    margin: 0,
    padding: 0
}));

const TenantLogo = styled('img')(() => ({
    width: '238px',
    height: '46px',
    marginTop: '32px',
    marginLeft: '24px'
}));

const GOEDigitalAdvisorLogo = styled('img')(() => ({
    width: '209px',
    height: '22px',
    zIndex: 2,
    position: 'absolute',
    marginTop: '40px',
    right: '60px'
}));

const StyledGuarntedDisclaimer = styled('tr')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'TT Commons Pro',
    fontWeight: 700,
    marginBottom: '20px',

    '& td': {
        padding: '4px 10px',
        border: `1px solid  ${theme.palette.common.black}`,
        color: `${theme.palette.common.black}`
    }
}));

const StyledClientDetails = styled('td')(({ theme }) => ({
    marginLeft: '24px',
    '& tr': {
        fontSize: '30px',
        fontFamily: 'TT Commons Pro',
        fontWeight: 400,
        color: 'hsla(217, 100%, 93%, 1)',
        paddingTop: '43px',
        display: 'block'
    },

    '& th': {
        fontSize: '30px',
        fontWeight: 600,
        fontFamily: 'TT Commons Pro',
        color: `${theme.palette.common.white}`,
        lineHeight: '7px',
        paddingTop: '21px',
        textAlign: 'left'
    }
}));

const StyledName = styled(Typography)(() => ({
    color: '#FFF',
    fontFamily: 'TT Commons Pro',
    fontSize: '127px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '112px',
    top: '420px',
    right: '136px',
    position: 'absolute'
}));

const StyledFooterDisclaimer = styled(Typography)(() => ({
    color: '#333',
    fontFamily: 'TT Commons Pro',
    fontSize: '12px',
    height: '16px',
    lineHeight: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    marginTop: '30px'
}));

export type PDFLandingPageNewCoverProps = {
    proposalPlanCreationDate: string;
    proposalPlanLastUpdateDate: string;
    proposalCreatedBy: string;
    proposalCreatedFor: string;
    globalConfig: {
        logo?: string;
        subdomain: string;
        disclaimers: {
            brandName: string;
        };
    };
};

const PDFLandingPageNewCover = ({
    proposalCreatedFor,
    proposalCreatedBy,
    proposalPlanCreationDate,
    proposalPlanLastUpdateDate,
    globalConfig
}: PDFLandingPageNewCoverProps) => {
    const { t } = useTranslation();
    const {
        logo,
        subdomain,
        disclaimers: { brandName }
    } = globalConfig;
    const isFranklinAdviceTenant = subdomain === 'advice';

    return (
        <Grid height={'1015px'} position={'relative'} marginBottom={'40px'}>
            <ImageContainer />
            <StyledName label={t('TEXT_GOE_REPORT')} />
            {isFranklinAdviceTenant && (
                <GOEDigitalAdvisorLogo src={GOEDigitalAdvisor} alt={'GOE Digital Advisor Image'} />
            )}
            <Grid
                width="100%"
                height="265mm"
                container
                justifyContent="space-between"
                flexDirection="column"
                margin={0}
                marginBottom={6}
                padding={2}
            >
                {' '}
                <TenantLogo src={isFranklinAdviceTenant ? FTLogo_White : logo} alt={brandName} />
                <StyledClientDetails>
                    <tr>{t('PDF_LABEL_PREPARED_FOR')}</tr>
                    <th>{proposalCreatedFor}</th>
                    <tr>{t('PDF_LABEL_PREPARED_BY')}</tr>
                    <th>{proposalCreatedBy}</th>
                    <tr>{t('PDF_LABEL_PLAN_CREATION_DATE')}</tr>
                    <th>{proposalPlanCreationDate}</th>
                    <tr>{`${t('PDF_LABEL_LAST_UPDATED')}:`}</tr>
                    <th>{proposalPlanLastUpdateDate}</th>
                </StyledClientDetails>
                <Grid
                    paddingRight={5}
                    sx={{
                        backgroundColor: '#fff',
                        position: 'relative',
                        zIndex: 1,
                        width: '100%',
                        paddingLeft: '24px'
                    }}
                >
                    <StyledGuarntedDisclaimer
                        style={{ bottom: isFranklinAdviceTenant ? '161px' : '65px', color: 'white' }}
                    >
                        <td>{t('PDF_LABEL_NOT_FDIC_INSURED')}</td>
                        <td>{t('PDF_LABEL_MAY_LOSE_MONEY')}</td>
                        <td>{t('PDF_LABEL_NO_BANK_GUARANTEE')}</td>
                    </StyledGuarntedDisclaimer>
                    <StyledFooterDisclaimer label={t('PDF_LABEL_DISCLAIMER_LANDING_PAGE')} />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default PDFLandingPageNewCover;
